import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNotePencilRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24 4.8c1.8 0 3.2 1.4 3.2 3.2v5h-2.4V8q-.1-.7-.8-.8h-8.8v4.4c0 2-1.6 3.6-3.6 3.6H7.2V24q.1.7.8.8h6v2.4H8A3 3 0 0 1 4.8 24v-9.9q0-1.2 1-2.2l6-6.2q1-.9 2.3-.9zm-15.8 8h3.4q1.1 0 1.2-1.2V8.2zM16.6 26l-.6 3v.1a.7.7 0 0 0 .9.7l3-.6q.9-.2 1.6-.9l6-5.9-4-4-6 6q-.7.6-.9 1.6M30 19.8a2.8 2.8 0 1 0-4-4l-1.4 1.5 4 4z" })
});
export default SvgNotePencilRegularIcon;
